<template>
  <v-navigation-drawer fixed app clipped
    :mini-variant.sync="mini"
    mini-variant-width="58"
    :width="$vuetify.breakpoint.mobile ? '100%' : 350"
    mobile-breakpoint="0"
    v-model="nav">
    <v-list-item class="px-2">
      <v-btn block text @click.stop="mini = !mini" class="d-flex justify-end" >
        <v-icon v-if="mini">mdi-chevron-right</v-icon>
        <v-icon v-else>mdi-chevron-left</v-icon>
      </v-btn>
    </v-list-item>
    <v-divider></v-divider>
    <v-container v-show="!mini">
      <v-overlay absolute :value="loading">
        <v-progress-circular size="80" indeterminate>
        </v-progress-circular>
      </v-overlay>
      <v-row>
        <v-col class="queue-list">
          <v-list two-line>
            <v-subheader>{{ $t('confr.menuTitle') }}</v-subheader>
            <Conference v-for="(conf, idx) in conferences"
              :conf="conf" :key="idx"/>
          </v-list>
        </v-col>
      </v-row>

      <v-row align="end" justify="center">
        <Pagination @loading="loading = !loading"/>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import Conference from './item'
import Pagination from './pagination'

export default {
  name: 'conferences-list',
  components: { Conference, Pagination },
  data () {
    return {
      loading: false,
      mini: true,
      nav: true
    }
  },
  computed: {
    ...mapGetters({ conferences: 'conferences/rooms' })
  }
}
</script>

<style scoped>
</style>
